import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../../../redux/store/store';
import LoadingSpinner from '../../../../../components/LoadingSpinner';
import { GetScheduleEmailThunk, resetScheduleEmailItemReducer } from '../../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice';
import EditScheduleEmailUpload from '../../../../../components/ScheduleEmail/EditScheduleEmailUpload/EditScheduleEmailUpload';
import { useTranslation } from 'react-i18next';

const EditScheduleEmailUploadScreen = () => {

    const { t } = useTranslation()
    const { id } = useParams();
    const dispatch = useAppDispatch()

    const scheduleEmail = useSelector((state: RootState) => state.scheduleEmailsData.scheduleEmail)
    const loadingInitalData = useSelector((state: RootState) => state.scheduleEmailsData.loadingInitalData)

    useEffect(() => {
        
        if(id)
            dispatch( GetScheduleEmailThunk(id) )

        return () => {
            dispatch( resetScheduleEmailItemReducer() )
        }
    }, [dispatch, id])

    if(loadingInitalData){
        return (
            <LoadingSpinner fullPage={true} />
        )
    }

    if(!id)
        return(
            <></>
        )
    
    if(!scheduleEmail){
        return (
            <div className="center">
                <p className="fs-24">{t("Emails:schedule:index:label_44")}</p>
            </div>
        )
    }

    return (
        <React.Fragment>
            <EditScheduleEmailUpload id={id} scheduleEmail={scheduleEmail} />
        </React.Fragment>
    )
}

export default EditScheduleEmailUploadScreen